import { render, staticRenderFns } from "./BarEChartHorizontal.vue?vue&type=template&id=44076230&scoped=true"
import script from "./BarEChartHorizontal.vue?vue&type=script&lang=js"
export * from "./BarEChartHorizontal.vue?vue&type=script&lang=js"
import style0 from "./BarEChartHorizontal.vue?vue&type=style&index=0&id=44076230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44076230",
  null
  
)

export default component.exports